module.exports = __webpack_public_path__ + "img/学术研究2.5c01c936.jpg";